import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { authLink } from './authLink';

// Katal deploy-time replacement — value injected into the bundle at deployment
const appSyncUrl = 'https://j7bltlylu5h6vf6jklszr57nvq.appsync-api.us-west-2.amazonaws.com/graphql';

const httpLink = new HttpLink({ uri: appSyncUrl });

let client: ApolloClient<unknown> | null = null;

export const getApolloClient = (): ApolloClient<unknown> => {
  if (!client) {
    client = new ApolloClient({
      cache: new InMemoryCache(),
      link: ApolloLink.from([authLink, httpLink]),
    });
  }
  return client;
};
